import { RootState } from '@core/Store'

export const selectIsRadioPlaying = (state: RootState): boolean => state.navigation.isRadioPlaying
